import { useEffect, useRef, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import API from "../../utility/API-endPoints";
import ExpandableGrid, { ExpandableRow } from "../../components/Grid/ExpandableGrid";
import Select from "react-select";
import PlotDateRangePicker from "../../components/PlotDatePicker/PlotDateRangePicker";
import { useNavigate } from "react-router-dom";
import { PiExport } from "react-icons/pi";

const headerRed: GridHeader[] = [
    {
        title: "Agent",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Project Name",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Customer",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Booking ID",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Booking Value",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Payment Received",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Commission (%)",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Commission Amount",
        class: "text-left",
        isSorting: false,
    }
];

const headerGreen: GridHeader[] = [
    {
        title: "Agent",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Project Name",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Customer",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Booking ID",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Booking Value",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Payment Received",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Commission (%)",
        class: "text-left",
        isSorting: false,
    }
];

const typeOptions = [
    { value: "amount", label: "Amount" },
    { value: "percentage", label: "Percentage" },
]

const AgentReport = () => {
    const navigate = useNavigate();
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
    const [pressedKeys, setPressedKeys] = useState(new Set());
    const [projectList, setProjectList] = useState<any[]>([]);
    const [isLoadingProject, setIsLoadingProject] = useState<boolean>(false);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [isLoadingVendor, setIsLoadingVendor] = useState<boolean>(false);
    const [selectedProject, setSelectedProject] = useState<string>("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [selectedVendor, setSelectedVendor] = useState<string>("");
    const [agentOptions, setAgentOptions] = useState<any[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<string>("");
    const [selectedType, setSelectedType] = useState<string>("");
    const [amount, setAmount] = useState<string>("");
    const [agentCount, setAgentCount] = useState<number>(0);
    const [headers, setHeaders] = useState<GridHeader[]>(headerGreen);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "AGENTS"));
            !projectList.length && getProjectList();
            !agentOptions.length && getAgentList();
        }
    }, [token]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [pressedKeys]);

    useEffect(() => {
        showHiddenFields && getAgentReportList(1);
        setHeaders(showHiddenFields ? headerRed : headerGreen);
    }, [showHiddenFields]);

    const getAgentReportList = (offset: number) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) return;
        setIsLoading(true);
        WebService.getAPI({
            action: `${API.AGENT_COMMISSION_REPORT}?limit=10&offset=${offset ? offset - 1 : 0}&project_id=${selectedProject}&amount=${amount}&agent_uuid=${selectedAgent}&type=${selectedType}`,
            body: null,
            is_session: showHiddenFields
        })
            .then((res: any) => {
                setIsLoading(false);
                let rows: GridRow[] = [];
                setAgentCount(res.count);
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i]?.agent ? res.list[i]?.agent?.agent_name + " (" + res.list[i]?.agent?.agent_phone + ")" : "N/A" });
                    columns.push({ value: res.list[i].project ? res.list[i].project?.project_name : "N/A" });
                    columns.push({ value: res.list[i]?.customer_name + " (" + res.list[i]?.customer_phone + ")" });
                    columns.push({ value: res.list[i].booking ? res.list[i]?.booking?.book_id : "N/A" });
                    columns.push({ value: res.list[i].booking ? HelperService.getCurrencyFormatter(res.list[i]?.booking?.total_cost) : "N/A" });
                    columns.push({ value: res.list[i].booking ? HelperService.getCurrencyFormatter(res.list[i]?.booking?.paid_amount) : "N/A" });
                    columns.push({ value: res.list[i].agent_commission ? res.list[i]?.agent_commission : "N/A" });
                    showHiddenFields && columns.push({ value: res.list[i].agent_commission_amount ? HelperService.getCurrencyFormatter(res.list[i]?.agent_commission_amount) : "N/A" });
                    rows.push({ data: columns });
                }
                setRows(rows);
            }).catch((e) => { setIsLoading(false); });
    };

    const onSortList = (offset: number) => {
        getAgentReportList(offset);
    };

    const exportAgentReport = () => {
        WebService.getAPI({
            action: `export/agent-commission/report?project_id=${selectedProject}&amount=${amount}&agent_uuid=${selectedAgent}&type=${selectedType}`,
            body: null,
            responseType: 'arraybuffer',
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `agent_report_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => {
            toast.error("Failed to export agent report");
        });
    };

    const handleKeyUp = (e: any) => {
        const key = e.key.toLowerCase();
        if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) setShowHiddenFields(true);
        setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
    };

    const handleKeyDown = (e: any) => {
        const key = e.key.toLowerCase();
        setPressedKeys((prev: any) => new Set([...prev, key]));
    };

    const getProjectList = () => {
        setIsLoadingProject(true);
        WebService.getAPI({ action: "get/project/list" })
            .then((res: any) => {
                setProjectList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.project_name } } }));
                setIsLoadingProject(false);
            })
            .catch((e: any) => { })
            .finally(() => {
                setIsLoadingProject(false);
            });
    };

    const getAgentList = () => {
        WebService.getAPI({ action: API.ALL_AGENT_LIST })
            .then((response: any) => {
                setAgentOptions(response.list.map((agent: any) => ({ value: agent.uuid, label: agent.agent_name, commission_amount: agent.commission_amount, commission_type: agent.commission_type })));
            }).catch(error => {
                toast.error("Failed to fetch agent list");
                setAgentOptions([]);
            });
    };


    return (
        <>
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center  mb-2"> <PageTitle title="Agent Report" backArrow={false} active={showHiddenFields} />
                    <div>
                        {permissions && permissions.can_write && permissions.can_update && <Button className="btn btn-brand-1 ms-2" onClick={() => { exportAgentReport(); }} > <PiExport size={20} className="ms-1" /> Export Agent Report </Button>}
                    </div>
                </div>
                <div className="table-card">
                    {
                        <div className="row mb-3">
                            <div className="col-2">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={projectList}
                                    onChange={(e: any) => { setSelectedProject(e ? e.value : ""); }}
                                    value={projectList?.find((option) => option.value === selectedProject)}
                                    placeholder="Select Project"
                                />
                            </div>
                            <div className="col-2">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={agentOptions}
                                    onChange={(e: any) => {
                                        setSelectedAgent(e ? e.value : "");
                                        if (e && e.value) {
                                            setSelectedType(e.commission_type);
                                            setAmount(e.commission_amount)
                                        };
                                    }}
                                    value={agentOptions?.find((option) => option.value === selectedAgent)}
                                    placeholder="Select Agent"
                                />
                            </div>
                            <div className="col-2">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={typeOptions}
                                    onChange={(e: any) => { setSelectedType(e ? e.value : ""); }}
                                    value={typeOptions?.find((option) => option.value === selectedType)}
                                    placeholder="Select Type"
                                />
                            </div>
                            <div className="col-2">
                                <div className="input-group mb-1">
                                    <input
                                        type="text"
                                        className="form-control ps-3 p-2"
                                        placeholder="Enter Amount"
                                        onChange={(e) => { setAmount(e.target.value); }}
                                        onKeyPress={HelperService.allowNewDecimalValue}
                                        value={amount}
                                    />
                                </div>
                            </div>
                            <div className="col-2">
                                <PlotDateRangePicker start_date={startDate} end_date={endDate} onDateChange={(start_date, end_date) => { setStartDate(start_date); setEndDate(end_date); }} />
                            </div>
                            <div className="col-2"> <Button className="btn-brand-1" onClick={() => { getAgentReportList(1) }} >  Search </Button>  </div>
                        </div>
                    }
                    <Grid
                        rows={rows}
                        headers={headers}
                        onPageChange={getAgentReportList}
                        errorMessage={"No Data Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={agentCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default AgentReport;